import { render, staticRenderFns } from "./email-preferences.vue?vue&type=template&id=796cfc73"
import script from "./email-preferences.vue?vue&type=script&lang=js"
export * from "./email-preferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports